<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {

  created() {
    document.title = '百行风洞'
  }
}
</script>
<style lang="less">

</style>
